import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const UrbanoPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#f5e8ff',
      100: '#e5c2ff',
      200: '#cc88ff',
      300: '#b34dff',
      400: '#9a1fff',
      500: '#5C068C',  // brand purple
      600: '#4e057a',
      700: '#3f0461',
      800: '#2f0349',
      900: '#1f0230',
      950: '#100118',
    },
    // ── Tamaño de fuente base para mensajes/alertas
    message: {
      text: {
        fontSize: '0.875rem',
      },
    },
    // ── Controla padding/border-radius de todos los inputs (InputText, Password, Select, etc.)
    formField: {
      paddingX:     '0.75rem',
      paddingY:     '0.6rem',
      borderRadius: '0.5rem',
      sm: {
        fontSize: '0.8rem',
        paddingX: '0.6rem',
        paddingY: '0.4rem',
      },
    },
    colorScheme: {
      light: {
        primary: {
          color:        '#5C068C',
          inverseColor: '#ffffff',
          hoverColor:   '#4e057a',
          activeColor:  '#3f0461',
        },
        highlight: {
          background:      'rgba(92, 6, 140, 0.08)',
          focusBackground: 'rgba(92, 6, 140, 0.14)',
          color:           '#5C068C',
          focusColor:      '#3f0461',
        },
        surface: {
          0:   '#ffffff',
          50:  '#f8f9fa',
          100: '#f1f3f5',
          200: '#e9ecef',
          300: '#dee2e6',
          400: '#ced4da',
          500: '#adb5bd',
          600: '#868e96',
          700: '#495057',
          800: '#343a40',
          900: '#212529',
          950: '#101214',
        },
      },
      dark: {
        primary: {
          color:        '#b34dff',
          inverseColor: '#1f0230',
          hoverColor:   '#cc88ff',
          activeColor:  '#e5c2ff',
        },
        highlight: {
          background:      'rgba(179, 77, 255, 0.16)',
          focusBackground: 'rgba(179, 77, 255, 0.24)',
          color:           '#e5c2ff',
          focusColor:      '#ffffff',
        },
        surface: {
          0:   '#ffffff',
          50:  '#f8f9fa',
          100: '#1e2128',
          200: '#252a32',
          300: '#2d333d',
          400: '#373e4a',
          500: '#4a5260',
          600: '#6b7585',
          700: '#9aa0ac',
          800: '#c2c7ce',
          900: '#e4e6ea',
          950: '#f4f5f7',
        },
      },
    },
  },
});

export default UrbanoPreset;
